import { BfxBlotterContextMenuItem, BfxBlotterAction } from "../../../../shared/cubiq-services";
import { BfxBlotterOpsIntContextMenuItemState } from "./BfxBlotterOpsIntContextMenuItemState";

export class BfxBlotterOpsIntContextMenuItem extends BfxBlotterContextMenuItem<any> {
  public state: BfxBlotterOpsIntContextMenuItemState = new BfxBlotterOpsIntContextMenuItemState();
  constructor(
    public actionId: BfxBlotterAction,
    title: string = "",
    public iconClass: string = null,
  ) {
    super(
      actionId,
      title,
      () => {
        return;
      },
      () => {
        return;
      },
    );
    this.state.title = title;
    this.state.enabled = null;
    this.state.available = null;
    if (typeof iconClass === "string") {
      this.state.iconClass = iconClass;
    }
  }
}
